<template>
    <v-dialog v-model="modal" width="600">
        <v-card>
            <v-card-title class="d-flex justify-space-between gc-2">
                {{ $t('flights.baggage_rules') }}
                <v-icon data-cy="close" size="x-small" class="mt-2 ml-auto" @click="modal = false"> mdi-close </v-icon>
            </v-card-title>
            <v-card-text>
                <v-table density="compact">
                    <thead>
                        <tr>
                            <th>
                                {{ $t('flights.flight') }}
                            </th>
                            <th class="text-capitalize">
                                {{ $t('passenger', 1) }}
                            </th>
                            <th>
                                {{ $t('flights.baggage') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(
                                {itineraryName, passengerType, baggage: {unitCode, unitQuantity}}, index
                            ) of baggageInfo"
                            :key="index"
                        >
                            <td>
                                {{ itineraryName }}
                            </td>
                            <td>
                                {{ $t(`passengerType.${passengerType}`) }}
                            </td>
                            <td v-if="+unitQuantity > 0">
                                {{ unitQuantity }} {{ $t(`flights.baggageType.${unitCode}`, +unitQuantity) }}
                            </td>
                            <td v-else>
                                {{ $t('not_included') }}
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class FlightBaggageRules extends Vue {
        @VModel() modal
        @Prop({required: true, type: Object}) service

        get baggageInfo() {
            return this.service.serviceDetailsContainer.flight.itineraries
                .map(({itineraryName, flightSegments: [{baggageInfo}]}) =>
                    baggageInfo.map(baggageInfo => ({itineraryName, ...baggageInfo}))
                )
                .flat()
        }
    }

    export default FlightBaggageRules
</script>
